let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("24i1v")), load("8bJvw")]).then(() => parcelRequire('9l7Vm'));